import { ReactNode } from 'react';

import { Text, Colors } from '@rockalingua/ui';

import { Container, TitleContainer } from './TeachersFeedback.styled';
import Carousel from './components/Carousel/Carousel';

type TeachersFeedbackProps = {
  button: ReactNode;
};

export default function TeachersFeedback({ button }: TeachersFeedbackProps) {
  return (
    <Container>
      <TitleContainer>
        <Text variant="title-big-grey-42" color={Colors.BLACK}>
          Teachers Feedback
        </Text>
      </TitleContainer>
      <Carousel items={testimonials} />
      {button}
    </Container>
  );
}

const testimonials = [
  {
    name: 'Sofia Petruzzelli',
    title: 'Marymount School, New York',
    description:
      'My students absolutely love Rockalingua! Their eyes are glued to the screen, the animation makes them laugh, and they have so much fun practicing their Spanish! They want to continue singing even after we finish!',
  },
  {
    name: 'Silvia Sánchez',
    title: 'Downsview Primary School, London',
    description:
      'Rockalingua makes my life as a teacher much easier. The songs are fun and engaging, and all the related worksheets and games help me to plan the lessons in no time! My students love all the catchy songs and even the parents have reported that they are singing them back at home!',
  },
  {
    name: 'Luis Giron-López',
    title: 'Bettie Weaver Elementary, Virginia',
    description:
      "Rockalingua is the best website for Spanish teachers and students that I've used. My students can't stop singing the songs, and even their parents know the lyrics!",
  },
];
